import { useCallback, useEffect, useRef, useState } from 'react';

// TODO Cover with unit tests, it's really needed, come on! :)
// TODO After it's covered with tests, consider implementation based on throttle from lodash
// Useful to reduce amount of re-renders of component that depends on rapidly changed value. Use this
// hook to throttle this value in parent component and pass it to target memoized component by prop.
export function useThrottleValue<Value>(value: Value, timeout: number) {
  const [throttledValue, setThrottledValue] = useState<Value>(value);
  const lastTriggered = useRef<number>(Date.now());
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const cancel = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  useEffect(() => {
    let remainingTime = getRemainingTime(lastTriggered.current, timeout);

    if (remainingTime === 0) {
      lastTriggered.current = Date.now();
      setThrottledValue(value);
      cancel();
    } else if (!timeoutRef.current) {
      timeoutRef.current = setTimeout(() => {
        remainingTime = getRemainingTime(lastTriggered.current, timeout);

        if (remainingTime === 0) {
          lastTriggered.current = Date.now();
          setThrottledValue(value);
          cancel();
        }
      }, remainingTime);
    }

    return cancel;
  }, [cancel, timeout, value]);

  return throttledValue;
}

function getRemainingTime(lastTriggeredTime: number, timeout: number) {
  const remainingTime = timeout - (Date.now() - lastTriggeredTime);

  return remainingTime < 0 ? 0 : remainingTime;
}
